import { Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import CasePersonDetail from "./case-balance-person-detail";
import CaseBalanceRestitutionDetail from "./case-balance-restitution-detail";
import CaseBalanceViolationDetail from "./case-balance-violation-detail";
import CaseBalanceVoilationTable from "./case-balance-voilation-table";
import useCaseBalance from "./useCaseBalance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getConfigs from "../../../GetConfigs";

const CaseBalanceDetail = ({ ...props }) => {
  const [form] = Form.useForm();
  const { isModalOpen, setIsModalOpen, handleViolationView, caseMaster, violationDetails } = useCaseBalance();
  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctTRCRPaymentsTxt",
  ]);

  useEffect(() => {
    const paymentData = caseMaster?.balances?.MAIN[0];
    form.setFieldsValue({ ...paymentData });
  }, [caseMaster?.balances?.MAIN, form]);

  return (

    <Row gutter={[16, 16]}>
      {configurations.ctTRCRPaymentsTxt && messageVisible && (
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctTRCRPaymentsTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <CasePersonDetail form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={11} lg={11} md={11} sm={23} xs={23}>
        <CaseBalanceRestitutionDetail form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <CaseBalanceViolationDetail form={form} caseMaster={caseMaster} />
      </Col>
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <CaseBalanceVoilationTable isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} handleViolationView={handleViolationView} violationDetails={violationDetails} form={form} />
      </Col>
    </Row>
  );
};

export default CaseBalanceDetail;
